export default {
  'YouTube and High Definition Videos': 'يوتيوب وفيديوهات عالية الوضوح',
  'Story videos (Instagram/Snaps/TikTok)': 'إضافة مقاطع فيديو لقصتك على (إنستغرام/سناب شات/تيك توك)',
  'Facebook and Instagram Feed videos': 'إضافة فيديوهات على إنستغرام وفيسبوك',
  'Facebook and Twitter Portrait Videos': 'إضافة مقاطع فيديو بورتريه على تويتر وفيسبوك.',
  'Twitter and Facebbok Landscape Videos': 'إضافة مقاطع فيديو على تويتر وفيسبوك بالمقطع العرضي ',
  'Facebook Cover Videos And Blog Banners': 'إضافة مقاطع فيديو على غلاف الفيسبوك وشعار المدونات',
  'Fit': 'موافق',
  'Fill': 'ملء',
}